import { API } from '@Providers';

export default async function (id?: string) {
  const endpoint = id
    ? `/api/shelter/get-shopping-cart-session/${id}`
    : '/api/shelter/get-shopping-cart-session';

  return API({ endpoint });
}
